/**
 * Kept local so the store does not pull in `components/SaveContact/constants`,
 * which loads the `lusha-integrations-widgets` UMD bundle.
 * Source of truth: `ENABLED_INTEGRATION_STATUS` there.
 */
export const ENABLED_INTEGRATION_STATUS = 'enabled';
